import { useAppDispatch, useAppSelector } from 'state/hooks';
import {
  ODAnalysis,
  selectAnalysisStatus,
  selectODUIMode,
  setShowViewAllModal,
  useGetAnalysesQuery,
} from 'state/originDestinationSlices';
import { selectCurrentAnalysisId, selectProject } from 'state/workflowSlice';

import { ODUIMode } from 'appConstants';
import { ItemList } from 'appTypes';
import { StlList } from 'features/common/StlList/StlList';
import StlRecentList from 'features/common/StlList/StlRecentList';

import ODCard from './ODCard/ODCard';
import { useODUIMode } from './hooks/useODUIMode';

import styles from './od.module.css';

export default function ODList({
  limit,
  highlightSelected,
  filters,
  wide,
  selectedOnly,
  excludeSelected,
}: ItemList) {
  const dispatch = useAppDispatch();

  const project = useAppSelector(selectProject);
  const currentAnalysisId = useAppSelector(selectCurrentAnalysisId);

  const { currentData: analyses } = useGetAnalysesQuery(project, {
    skip: !project,
  });
  const { setViewMode } = useODUIMode();

  const onItemClick = (_e: React.MouseEvent, item: ODAnalysis) => {
    dispatch(setShowViewAllModal(false));
    setViewMode(item);
  };
  return (
    <StlList<ODAnalysis>
      limit={limit}
      highlightSelected={highlightSelected}
      filters={filters}
      wide={wide}
      idAccessor="analysis_id"
      filterBy="created_at"
      onItemClick={onItemClick}
      currentItemId={currentAnalysisId}
      data={analyses}
      CardComponent={ODCard}
      itemName="Origin Destination analyses"
      classes={wide && [styles.odListWide]} // modal mode
      selectedOnly={selectedOnly}
      excludeSelected={excludeSelected}
    />
  );
}

export function RecentODList() {
  const dispatch = useAppDispatch();

  const project_slug = useAppSelector(selectProject);
  const currentAnalysisId = useAppSelector(selectCurrentAnalysisId);
  const uiMode = useAppSelector(selectODUIMode);
  const status = useAppSelector(selectAnalysisStatus);

  const { currentData: analyses } = useGetAnalysesQuery(project_slug, {
    skip: !project_slug,
  });

  const onViewAll = () => {
    dispatch(setShowViewAllModal(true));
  };

  return (
    <StlRecentList<ODAnalysis>
      idAccessor="analysis_id"
      status={status}
      viewMode={uiMode === ODUIMode.View}
      currentId={currentAnalysisId}
      items={analyses || []}
      onViewAll={onViewAll}
      listComponent={ODList}
      classes={uiMode === ODUIMode.View ? [styles.odRecentList] : []}
    />
  );
}
